import "core-js/stable"
import "regenerator-runtime/runtime"


import $ from 'jquery'
window.$ = $
window.jQuery = $

import 'materialize-css'
import './materialize_init' // cookies
import './defer_loading_images'
import './ella_account'
// import './cookies' // cookies
import '../../teasers/package_group_teaser_a'
import '../../groups/group_f'
import '../scss/style.scss'
import './didomi'


const urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results) {
        return results[1] || 0;
    } else {
        return 0;
    }
}

window.addEventListener('load', (event) => {
    if (window.adBlocker === undefined) {
        console.log('Ad blocker is ON (Yes)')
        ga('send', {
            hitType: 'event',
            eventCategory: 'Adblocker',
            eventAction: 'Yes',
            eventLabel: window.location.href
        });
    } else {
        console.log('Ad blocker is OFF (No)')
        ga('send', {
            hitType: 'event',
            eventCategory: 'Adblocker',
            eventAction: 'No',
            eventLabel: window.location.href
        });
    }
});

window.addEventListener('load', (event) => {
    const burger = document.querySelector('.menu_burger');
    const nav = document.querySelector('.menu_burger__content');
    const button = document.querySelector('.burger-icon');
    burger.addEventListener('click', ()=>{
        nav.classList.toggle('show')
        if(button.classList.contains('fa-bars')){
          button.classList.remove('fa-bars')
          button.classList.add('fa-times')
        }else{
            button.classList.remove('fa-times')
            button.classList.add('fa-bars')
        }
    })
})